import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"0px","max-height":"0px","overflow":"hidden"} }, [
  /*#__PURE__*/_createElementVNode("canvas", { id: "page_canvas" })
], -1)
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "pb-5" }
const _hoisted_4 = { class: "d-flex align-items-center landingSubtitle" }
const _hoisted_5 = { class: "pb-5 pt-5" }
const _hoisted_6 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_7 = { class: "fv-row mb-5" }
const _hoisted_8 = {
  class: "dropzone",
  id: "kt_dropzonejs_libro_familia"
}
const _hoisted_9 = { class: "dz-message needsclick" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-up text-primary fs-3x" }, null, -1)
const _hoisted_11 = { class: "ms-4" }
const _hoisted_12 = { class: "fs-5 fw-bolder text-gray-900 mb-1" }
const _hoisted_13 = { class: "fs-7 fw-bold text-gray-400" }
const _hoisted_14 = { class: "pb-5 pt-5" }
const _hoisted_15 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_16 = { class: "form-floating mb-5" }
const _hoisted_17 = ["aria-label"]
const _hoisted_18 = {
  disabled: "",
  value: ""
}
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  class: "form-label mb-3 required",
  for: "tipologiaFamilia"
}
const _hoisted_21 = { class: "form-floating mb-5" }
const _hoisted_22 = ["aria-label"]
const _hoisted_23 = {
  disabled: "",
  value: ""
}
const _hoisted_24 = ["value"]
const _hoisted_25 = {
  class: "form-label mb-3 required",
  for: "numeroMenores"
}
const _hoisted_26 = { class: "form-floating mb-5" }
const _hoisted_27 = ["aria-label"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: null
}, "-", -1)
const _hoisted_29 = { value: true }
const _hoisted_30 = { value: false }
const _hoisted_31 = {
  class: "form-label mb-3 required",
  for: "conIngresos"
}
const _hoisted_32 = {
  key: 0,
  class: "mb-5 fv-row"
}
const _hoisted_33 = { class: "input-group" }
const _hoisted_34 = { class: "form-floating flex-grow-1" }
const _hoisted_35 = { class: "form-label mb-3 required" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", {
  style: {"border":"none"},
  class: "form-control-solid input-group-text"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-euro-sign fs-2x" })
], -1)
const _hoisted_37 = { class: "pb-5 pt-5" }
const _hoisted_38 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_39 = { class: "text-gray-400 fw-bold fs-6 pb-2" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-question-circle text-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#iam_familia_prioritaria",
  role: "button"
}, null, -1)
const _hoisted_41 = { class: "form-floating mb-5" }
const _hoisted_42 = ["aria-label"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: null
}, "-", -1)
const _hoisted_44 = { value: true }
const _hoisted_45 = { value: false }
const _hoisted_46 = {
  class: "form-label mb-3 required",
  for: "familiaPrioritaria"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_CurrencyInput = _resolveComponent("CurrencyInput")!
  const _component_FamiliaPrioritariaModal = _resolveComponent("FamiliaPrioritariaModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("paso2")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("LibroFamiliaGroupLabel")), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.$t("LibroFamiliaAccion")), 1),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("LibroFamiliaDescripcion")), 1)
            ])
          ])
        ]),
        _createVNode(_component_ErrorMessage, {
          name: "libroFamilia",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("h2", _hoisted_15, _toDisplayString(_ctx.$t("SituacionFamiliarGroupLabel")), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _withDirectives(_createElementVNode("select", {
          class: "form-select form-select-solid",
          name: "tipologiaFamilia",
          "aria-label": _ctx.$t('SituacionFamiliarTipologiaFamiliaLabel'),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tipologiaFamilia) = $event))
        }, [
          _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.$t("OpcionInicialTratamiento")), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tipologiasFamilia, (tipologia, i) => {
            return (_openBlock(), _createElementBlock("option", {
              value: tipologia.id,
              key: i
            }, _toDisplayString(tipologia.nombre), 9, _hoisted_19))
          }), 128))
        ], 8, _hoisted_17), [
          [_vModelSelect, _ctx.tipologiaFamilia]
        ]),
        _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("SituacionFamiliarTipologiaFamiliaLabel")), 1),
        _createVNode(_component_ErrorMessage, {
          name: "tipologiaFamilia",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ]),
      _createElementVNode("div", _hoisted_21, [
        _withDirectives(_createElementVNode("select", {
          class: "form-select form-select-solid",
          name: "numeroMenores",
          "aria-label": _ctx.$t('SituacionFamiliarNumeroMenoresLabel'),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.numeroMenores) = $event))
        }, [
          _createElementVNode("option", _hoisted_23, _toDisplayString(_ctx.$t("OpcionInicialTratamiento")), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numeroMenoresOpciones, (numeroM, i) => {
            return (_openBlock(), _createElementBlock("option", {
              value: numeroM.id,
              key: i
            }, _toDisplayString(numeroM.nombre), 9, _hoisted_24))
          }), 128))
        ], 8, _hoisted_22), [
          [_vModelSelect, _ctx.numeroMenores]
        ]),
        _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("SituacionFamiliarNumeroMenoresLabel")), 1),
        _createVNode(_component_ErrorMessage, {
          name: "numeroMenores",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ]),
      _createElementVNode("div", _hoisted_26, [
        _withDirectives(_createElementVNode("select", {
          class: "form-select form-select-solid",
          id: "conIngresos",
          name: "conIngresos",
          "aria-label": _ctx.$t('SituacionFamiliarConIngresosLabel'),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.conIngresos) = $event))
        }, [
          _hoisted_28,
          _createElementVNode("option", _hoisted_29, _toDisplayString(_ctx.$t("SituacionFamiliarConIngresosSi")), 1),
          _createElementVNode("option", _hoisted_30, _toDisplayString(_ctx.$t("SituacionFamiliarConIngresosNo")), 1)
        ], 8, _hoisted_27), [
          [_vModelSelect, _ctx.conIngresos]
        ]),
        _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t("SituacionFamiliarConIngresosLabel")), 1),
        _createVNode(_component_ErrorMessage, {
          name: "conIngresos",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ]),
      (_ctx.conIngresos)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_CurrencyInput, {
                  modelValue: _ctx.ingresos,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ingresos) = $event)),
                  modelModifiers: { lazy: true },
                  options: {
              currency: 'EUR',
              locale: 'es-ES',
              currencyDisplay: 'symbol',
              precision: 2,
              hideCurrencySymbolOnFocus: true,
              hideGroupingSeparatorOnFocus: true,
              hideNegligibleDecimalDigitsOnFocus: true,
              autoDecimalDigits: false,
              useGrouping: true,
              accountingSign: false,
            },
                  type: "text",
                  name: "ingresos",
                  class: "form-control form-control-lg form-control-solid",
                  placeholder: "ej. 11000.21"
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t("FamiliaIngresosValorLabel")), 1)
              ]),
              _hoisted_36,
              _createVNode(_component_ErrorMessage, {
                name: "ingresos",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("h2", _hoisted_38, _toDisplayString(_ctx.$t("FamiliaPrioritariaGroupLabel")), 1)
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createTextVNode(_toDisplayString(_ctx.$t("FamiliaPrioritariaNoticeLabel")) + " ", 1),
        _hoisted_40
      ]),
      _createElementVNode("div", _hoisted_41, [
        _withDirectives(_createElementVNode("select", {
          class: "form-select form-select-solid",
          id: "familiaPrioritaria",
          name: "familiaPrioritaria",
          "aria-label": _ctx.$t('FamiliaPrioritariaLabel'),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.familiaPrioritaria) = $event))
        }, [
          _hoisted_43,
          _createElementVNode("option", _hoisted_44, _toDisplayString(_ctx.$t("FamiliaPrioritariaSi")), 1),
          _createElementVNode("option", _hoisted_45, _toDisplayString(_ctx.$t("FamiliaPrioritariaNo")), 1)
        ], 8, _hoisted_42), [
          [_vModelSelect, _ctx.familiaPrioritaria]
        ]),
        _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t("FamiliaPrioritariaLabel")), 1),
        _createVNode(_component_ErrorMessage, {
          name: "familiaPrioritaria",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ])
    ]),
    _createVNode(_component_FamiliaPrioritariaModal)
  ], 64))
}